<template>
  <div class="progressbar-group">
    <div class="progressbar" :class="[color]">
        <Motion :value="percentageNumeric" tag="div">
            <span class="progress" slot-scope="props" :max="max" :style="{ width: `${props.value}%`}"></span>
        </Motion>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 20
        },
        max: {
            type: Number,
            default: 100
        },
        color: {
            type: String
        }
    },
    computed: {
        percentageNumeric() {
            if (this.value === 0 && this.max === 0) {
                return 100;
            }
            return (this.value / this.max) * 100;
        },
        percentage() {
            if (this.value === 0 && this.max === 0) {
                return 100;
            }
            var pct = (this.value / this.max) * 100;
            pct = pct.toFixed(2);
            if (pct < 0) {
                pct = 0;
            } else if (pct > 100) {
                pct = 100;
            }
            return pct;
        },
        bar_style() {
            return {
                width: this.percentage + "%"
            };
        }
    }
};
</script>

<style lang="less">
@import (reference) "~@/assets/less/general.less";

@progressbar-bg: fade(@gray-dark, 30%);
@progressbar-progress-bg: @white;
@progressbar-text: @gray-mid;
@progressbar-max-width: 440px;
@progressbar-height: 10px;
@progressbar-small-height: 8px;

.progressbar-group {
    &.small {
        .progressbar {
            height: @progressbar-small-height;
            border-radius: @progressbar-small-height;

            > div {
                height: @progressbar-height;
                border-radius: @progressbar-height;
            }

            .progress {
                border-radius: 0 @progressbar-height @progressbar-height 0;

                &:first-child {
                    border-radius: @progressbar-height;
                }
            }

            @motion-height: @progressbar-height;

            .motion {
                height: @motion-height;
                border-radius: @progressbar-height;
            }
        }
    }

    .text {
        .fontsize-xxl;
        .font-regular;
        color: @progressbar-text;
        display: block;
        margin: 30px 0;
    }

    .progressbar {
        width: 100%;
        height: @progressbar-height;
        border-radius: @progressbar-height;
        position: relative;
        background-color: @progressbar-bg;
        margin: 0 auto;
        max-width: @progressbar-max-width;

        position: relative;

        > div {
            width: 100%;
            height: @progressbar-height;
            position: absolute;
            top: @progressbar-small-height - @progressbar-height;
            right: 0;
            border-radius: @progressbar-height;
        }

        .progress {
            display: inline-block;
            float: right;
            width: 20px;
            height: 100%;
            border-radius: 0 @progressbar-height @progressbar-height 0;
            margin-right: -4px;
            position: relative;
            z-index: 1;
            background-color: @progressbar-progress-bg;

            &[style="width: 0%;"] {
                display: none;
            }

            &:first-child {
                border-radius: @progressbar-height;
                margin-right: 0;
                z-index: 2;
            }
        }

        @motion-height: 8px;
        @motion-width: ~"calc(@{progressbar-max-width} * 0.6)";

        .motion {
            width: @motion-width;
            height: @motion-height;
            background-color: fade(@gray-mid, 12%);
            position: absolute;
            border-radius: @progressbar-height;
        }
    }
}
</style>
